import { render } from "./footer.vue?vue&type=template&id=14be6fc3&scoped=true"
const script = {}

import "./footer.vue?vue&type=style&index=0&id=14be6fc3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14be6fc3"]])

export default __exports__